import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';

import Login from './pages/Login';
import AppLayout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import Contacts from './pages/Contacts';
import Properties from './pages/Properties';
import Deals from './pages/Deals';
import Tasks from './pages/Tasks';
import Calls from './pages/Calls';
import SiteVisits from './pages/SiteVisits';
import Reports from './pages/Reports';
import Admin from './pages/Admin';
import Bookings from './pages/Bookings';
import Payments from './pages/Payments';
import Finance from './pages/Finance';
import Registry from './pages/Registry';

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const RequirePermission = ({ module, action = 'view', children }) => {
  const { hasPermission } = useAuth();
  if (!hasPermission(module, action)) return <Navigate to="/dashboard" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route
              path="/"
              element={
                <Protected>
                  <AppLayout />
                </Protected>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="leads" element={<Leads />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="properties" element={<Properties />} />
              <Route path="deals" element={<Deals />} />
              <Route path="tasks" element={<Tasks />} />
              <Route path="calls" element={<Calls />} />
              <Route path="site-visits" element={<SiteVisits />} />
              <Route path="bookings" element={<Bookings />} />
              <Route path="payments" element={<Payments />} />
              <Route path="finance" element={<Finance />} />
              <Route path="registry" element={<Registry />} />
              <Route path="reports" element={<Reports />} />
              <Route path="admin" element={<RequirePermission module="admin" action="view"><Admin /></RequirePermission>} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
